import { AxiosError } from 'axios';
import instance from '../config/axios';

export interface VerifyProductBarcodeResult {
  verified: boolean;
  productId: number;
  productName: string;
  scannedBarcode: string;
  info: string;
}

export const verifyProductBarcode = async (
  accessToken: string,
  orderId: string,
  barcode: string,
): Promise<VerifyProductBarcodeResult | number | undefined> => {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/order-details/${orderId}/verify-barcode`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: { barcode },
    });

    return response.data;
  } catch (e) {
    return (e as AxiosError).response?.status;
  }
};
